import { Spin } from "antd";
import styled, { keyframes } from "styled-components";
import { useLoading } from "../../../hooks/useLoading";
import { LoadingOutlined } from "@ant-design/icons";

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 40, 49, 0.75);
  animation: ${fadeIn} 120ms ease;
`;

const SpinIcon = styled(LoadingOutlined)`
  font-size: 60px !important;
  color: #8e1616;
`;

export default function LoadingSpinner() {
  const { isLoading } = useLoading();
  if (!isLoading) return null;
  return (
    <Overlay>
      <Spin indicator={<SpinIcon spin />} />
    </Overlay>
  );
}
